import React from "react";
import Reveal from "../../components/Reveal";
import DrslHero from "../../components/cases/DrslHero";
import CaseArticleDrsl from "../../components/cases/CaseArticleDrsl";
import Footer from "../Footer";
import ContactCta from "../main_page/ContactCta";

export default function DrslCasePage() {
  return (
    <div className="case-detail-page">
      <Reveal as="section" variant="fade" threshold={0.15}>
        <DrslHero />
      </Reveal>

       <CaseArticleDrsl />

      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>

      <Footer />
    </div>
  );
}